import { graphql, useStaticQuery } from "gatsby";

export type IContactData = {
  allWpContact: {
    nodes: {
      contact_info: {
        contactInfoEmail: string;
        contactInfoName: string;
        contactInfoTitle: string;
      }[];
    };
  };
};

const useContactData = () => {
  const { allWpContact }: IContactData = useStaticQuery(
    graphql`
      {
        allWpContact {
          nodes {
            contact_info {
              contactInfoEmail
              contactInfoName
              contactInfoTitle
            }
          }
        }
      }
    `
  );
  return allWpContact.nodes;
};
export default useContactData;
